"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _helpers = require("../../utils/helpers");
var _settings = require("../../settings");
var _PageHeroModule = _interopRequireDefault(require("./../../scss/layout-wrappers/PageHero.module.scss"));
function PageHero(_ref) {
  let {
    layoutComponent = '',
    layoutProps = {}
  } = _ref;
  const [Layout, setLayout] = (0, _react.useState)(null);

  /**
   * load the layout component for this hero
   */
  (0, _react.useEffect)(() => {
    setLayout(_settings.pageHeroLayoutsMap.get(layoutComponent));
  }, [layoutComponent]);
  return /*#__PURE__*/_react.default.createElement("section", {
    className: (0, _helpers.classes)([_PageHeroModule.default['page-hero'], 'page-hero'])
  }, Layout !== null && /*#__PURE__*/_react.default.createElement(Layout, layoutProps));
}
var _default = exports.default = PageHero;